export default __webpack_public_path__ + "static/media/disease-trait.604481d8.png";